import { environment } from '../../environments/environment';

export const AppEnvironments = {
    Development: 'development',
    Production: 'production',
    CTD: 'ctd',
    Staging: 'staging',
};

export const ASRAppSettings = {
    BookingProgramSettings: "BookingProgramSettings",
    PendingAgreementsConfiguration: "PendingAgreementsConfiguration",
    ProductCategoryDateRange: "ProductCategoryDateRange"
}

export const WareHouseStaggingSettings = {
    ModuleName: "Warehouse_Pro",
    Settings: {
        RemarkConfigurationForShipmentTime: "RemarkConfigurationForShipmentTime",
        RemarkConfigurationForShipmentType: "RemarkConfigurationForShipmentType",
        RemarkConfigurationForDeliveryPoint: "RemarkConfigurationForDeliveryPoint",
        Warehouse_Pro: "Warehouse_Pro"
    }
}

export const BookingProgramSettings = {
    BookingProgramSettingStatus: "BookingProgramSettingStatus",
    BookingProcess: "BookingProcess",
};

export const PendingAgreementsConfiguration = {
    PendingAgreementStatus: "PendingAgreementStatus",
    SelectedEmailType: "SelectedEmailType",
    SelectedPendingBookingStatus: "SelectedPendingBookingStatus",
    SelectedPendingPrepayStatus: "SelectedPendingPrepayStatus",
    SelectedPendingOrderStatus: "SelectedPendingSalesOrderStatus",
    SelectedPendingQuoteStatus: "SelectedPendingQuoteStatus",
    SignatureRequiredStatus: "SignatureRequiredStatus",
    ButtonQuote: "ButtonQuote",
    ButtonPrepay: "ButtonPrepay",
    ButtonBooking: "ButtonBooking",
    HideQuoteButton: "HideQuoteButton",
    HidePrepayButton: "HidePrepayButton",
    HideBookingButton: "HideBookingButton",
    isSameBookingNumberStatus: "SameBookingNumberStatus",
    RemarkNumberForFarmAndField: 'RemarkNumberForFarmAndField',
    RemarkNumberForBookingProgram: 'RemarkNumberForBookingProgram',
};


export const PDFLinkPlaceHolder = "@PDFLinkPlaceHolder";
export const TransactionType = "@TransactionType";


export const TIME_SLOTS = [
    "00:00 AM",
    "01:00 AM",
    "02:00 AM",
    "03:00 AM",
    "04:00 AM",
    "05:00 AM",
    "06:00 AM",
    "07:00 AM",
    "08:00 AM",
    "09:00 AM",
    "10:00 AM",
    "11:00 AM",
    "12:00 PM",
    "01:00 PM",
    "02:00 PM",
    "03:00 PM",
    "04:00 PM",
    "05:00 PM",
    "06:00 PM",
    "07:00 PM",
    "08:00 PM",
    "09:00 PM",
    "10:00 PM",
    "11:00 PM",
];

export const StorageKeys = {
    Warehouse_Pro: "Warehouse_Pro",
    DataSet: "dataSet",
    TenantID: "TenantID",
    AgentId: "AgentId",
    AgentType: "AgentType",
    Settings: "settings",
    AgrisLicense: "agrisLicense",
    AuthActionListApiToken: "AuthActionListApiToken",
    AuthBookingApiToken: "AuthBookingApiToken",
    AuthEsignApiToken: "AuthEsignApiToken"
};

export const SignatureEmptyImage = "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";

export const ErrorMessages = {
    FormValidation: "please fill all mandatory fields",
};

export const CategoryType = {
    1: "Fertilizer",
    2: "Chemical",
    3: "Seed",
    4: "Supply",
    5: "Other",
    6: "Service",
    7: "Lime"
}

export const GlobalConstants = {
    DefaultRemoteServer: environment.GetwayRemoteServer.replace(/^https?:\/\//, '').replace(/\/$/, ''),

    DeviceName: "HOPPER",
    BookingProgramFieldStatuses: {
        Optional: "Optional",
        Required: "Required",
    },
    SalesTransactionModes: {
        Book: "Book",
        Prepay: "Prepay",

    }
}